:host {
  --width: 290px;
  --default-navbar-height: 48px;

  user-select: none;

  /* CSS vars set at navbar level */
  --z-index: var(--mobile-menu-z-index);
}

eco-assist-trigger-icon {
  z-index: 0;
}

.EcoSuiteNavbarMobileMenu,
.EcoSuiteNavbarMobileMenu *,
.EcoSuiteNavbarMobileMenu *::before,
.EcoSuiteNavbarMobileMenu *::after {
  box-sizing: border-box;
}

.EcoSuiteNavbarMobileMenu {
  display: flex;
  flex-direction: column;
  position: absolute;
  z-index: var(--z-index);
  inset-inline-end: 0;
  top: var(--navbar-height, var(--default-navbar-height));
  height: calc(100dvh - var(--navbar-height, var(--default-navbar-height)));
  padding: var(--pdt-space-100);
  width: var(--width);
  background-color: var(--pdt-color-surface);
  border-inline-start: 1px solid var(--pdt-color-border-subtle);
  box-shadow: var(--pdt-shadow-surface-popover-start);
  opacity: 0;
  pointer-events: none;
  transform: translateX(var(--width));
  transition: transform .2s ease, opacity .2s ease;

  :host(:dir(rtl)) & {
    transform: translateX(calc(var(--width) * -1));
  }

  &--open {
    transform: translateX(0);
    opacity: 1;
    pointer-events: all;
    transition-property: transform;

    :host(:dir(rtl)) & {
      transform: translateX(0);
    }
  }

  /* Visually-hidden focus targets used to wrap focus back into the panel
     when the user tabs past the first/last real focusable element. */
  &__sentinelStart,
  &__sentinelEnd {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip-path: inset(50%);
    white-space: nowrap;
    border: 0;
  }
}
